module.exports = __webpack_public_path__ + "static/media/D-flat-7ths.88b7aab8.png";